import { render, staticRenderFns } from "./_SelectedPanel.vue?vue&type=template&id=2365a60d&"
import script from "./_SelectedPanel.vue?vue&type=script&lang=js&"
export * from "./_SelectedPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports